import { styled } from '../../ui';

export const SearchInputContainer = styled.div`
  position: relative;
  flex-grow: 1;
`;
